import {capitalize} from 'lodash';
export const STATUS_ACTIVE = 'active';
export const STATUS_PENDING = 'pending';
export const STATUS_CANCELLED = 'cancelled';
export const STATUS_DEACTIVATED = 'deactivated';

export const statusTitle = (status) => {
  return capitalize(status);
}
